export const REQUEST_REDUCER_KEYS = {
  REDUCER: 'request',
  INITIALIZED: 'initialized',
  PENDING_COUNT: 'pending_count',
  ERROR: 'error',

  SYNC_TIMESTAMP: 'syncTimestamp',
}
